/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

(function ($) {
  if (!$ || !$.fn) {
    return;
  }

$(document).ready(function () {
  checkScreenSize();

  function checkScreenSize() {
    var newWindowWidth = $(window).width();
    if (newWindowWidth < 767) {
      $(".mobile-hidden.product-media-gallery").html("");
    }
  }

  // Dynamic reviews on hero

  if ($(".hero-section--product").length && $(".stars_review_yotpoo").length) {
    const observer = new MutationObserver(function (mutations) {
      if (
        $(".yotpo-sr-bottom-line-left-panel").text() &&
        $(".yotpo-sr-bottom-line-text").text()
      ) {
        $(".hero-section__star-container__stars span").text(
          $(".yotpo-sr-bottom-line-left-panel").text()
        );

        $(".hero-section__star-container__rating-count").text(
          $(".yotpo-sr-bottom-line-text").text()
        );

        $(".hero-section__star-container").addClass(
          "hero-section__star-container--active"
        );

        observer.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  $(".product-meta__price-list-container, .stars_review_yotpoo").wrapAll(
    "<div class='price_review' />"
  );
  $(".readall span").click(function () {
    $("html,body").animate(
      {
        scrollTop: $("#yotpo-reviews-main-widget").offset().top,
      },
      "slow"
    );
  });
  $("div:not(.product-prelaunch-info) > .readmore").click(function () {
    $("html,body").animate(
      {
        scrollTop: $(
          "product-image-with-text, .product-image-with-text, image-with-text, .shopify-section--image-with-text-horizon"
        ).offset().top,
      },
      "slow"
    );
  });

  // =============PDP mobile double click===========
  if (window.innerWidth < 992) {
    var x_count = 0;
    $("body").on(
      "click",
      ".product__media-item.is-selected .product__media-image-wrapper img",
      function () {
        x_count = x_count + 1;
        if (x_count > 1) {
          $(".product__zoom-button").trigger("click");
          x_count = 0;
        } else {
          setTimeout(function () {
            x_count = 0;
          }, 500);
        }
      }
    );
  }
  // ==============================End===============

  if ($(".featured-collections .coll-slider").length > 0) {
    var swiper = new Swiper(".featured-collections .coll-slider", {
      slidesPerView: 3,
      slideToClickedSlide: true,
      grabCursor: true,
      spaceBetween: 20,
      loop: false,
      breakpoints: {
        320: {
          slidesPerView: 1.5,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        980: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        1280: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
      },
      pagination: {
        el: ".swiper-pagination",
      },
      scrollbar: {
        el: ".with-slider .swiper-scrollbar",
        hide: false,
        draggable: true,
      },
    });
  }

  $(
    ".template-product .shopify-section--announcement-bar,.template-product .shopify-section--header"
  ).wrapAll('<div id="shopify-section-header" class="child" />');
  $(".flags_ca").click(function () {
    $("body").addClass("open-enus-drawer");
  });
  $(".drawer__close-button.tap-area, .enus-over").click(function () {
    $("body").removeClass("open-enus-drawer");
  });
  $('.drawer__close-button.tap-area[data-action="close"]').click(function () {
    console.log("close");

    if ($("collapsible-content[open]").length > 0) {
      $(".drawer__content").css("opacity", "0");
      $(".drawer__content").delay(1000).animate({ opacity: 1 }, 1000);
      $("collapsible-content[open] > .mobile-nav--backbtn").trigger("click");
    }
  });
  $('.header__icon-wrapper.tap-area[aria-controls="mobile-menu-drawer"]').click(
    function () {
      console.log("open");

      // $('.drawer__content').css('opacity', '0');
      // $('.drawer__content').delay(1000).animate({ opacity: 1 }, 1000);
      // $('.mobile-nav__item.mobile-nav__item-lv1').animate({ opacity: 1 }, 1000);
    }
  );

  //Play vidoe on header with page load -->
  setTimeout(function () {
    var videosrc = $("body").find("iframe").attr("data-src");
    $("body").find("iframe").attr("src", videosrc);
  }, 250);

  //Homepage Carousel START -->
  function moveToSelected(element) {
    if (element == "swiper-slide-next") {
      var selected = $(".swiper-slide-active").next();
    } else if (element == "swiper-slide-prev") {
      var selected = $(".swiper-slide-active").prev();
    } else {
      var selected = element;
    }
    var next = $(selected).next();
    var prev = $(selected).prev();
    var prevSecond = $(prev).prev();
    var nextSecond = $(next).next();
    $(selected).removeClass().addClass("swiper-slide-active");
    $(prev).removeClass().addClass("swiper-slide-prev");
    $(next).removeClass().addClass("swiper-slide-next");
    $(nextSecond).removeClass().addClass("nextRightSecond");
    $(prevSecond).removeClass().addClass("prevLeftSecond");
    $(nextSecond).nextAll().removeClass().addClass("hideRight");
    $(prevSecond).prevAll().removeClass().addClass("hideLeft");
  }

  function setimage() {
    // let img = $("div.selected").find("img").attr("attr");
    let img = $("div.swiper-slide-active").find("img").attr("attr");
    $("div.swiper-slide img").removeAttr("enabled");
    $("div.swiper-slide-active img").attr("enabled", "yes");
    $(
      "#shopify-section-template--16781858504961__4bc85c9c-f71a-47bb-95c4-d41af74c1762 .section__color-wrapper"
    ).css("background-image", "url('" + img + "')");
    $(
      "#shopify-section-template--16781858504961__4bc85c9c-f71a-47bb-95c4-d41af74c1762 .section__color-wrapper"
    ).css("background-size", "100% 80%");
    $(
      "#shopify-section-template--16781858504961__4bc85c9c-f71a-47bb-95c4-d41af74c1762 .section__color-wrapper"
    ).css("background-repeat", "no-repeat");
  }

  $(document).keydown(function (e) {
    switch (e.which) {
      case 37: // left
        moveToSelected("swiper-slide-prev");
        break;
      case 39: // right
        moveToSelected("swiper-slide-next");
        break;
      default:
        return;
    }
    setimage();
    e.preventDefault();
  });

  //on div image click
  $("#banner_swiper div.swiper-slide").click(function (e) {
    let img = $(this).find("img").attr("attr");
    console.log("this", $(this).find("img").attr("attr"));
    $(
      "#shopify-section-template--16781858504961__4bc85c9c-f71a-47bb-95c4-d41af74c1762 .section__color-wrapper"
    ).css("background", "url('" + img + "')");
    $(
      "#shopify-section-template--16781858504961__4bc85c9c-f71a-47bb-95c4-d41af74c1762 .section__color-wrapper"
    ).css("background-size", "100% 100%");
    $(
      "#shopify-section-template--16781858504961__4bc85c9c-f71a-47bb-95c4-d41af74c1762 .section__color-wrapper"
    ).css("background-repeat", "no-repeat");
    // moveToSelected($(this));
    setTimeout(function () {
      $("div.swiper-slide img").removeAttr("enabled");
      $("div.swiper-slide-active img").attr("enabled", "yes");
    }, 1000);
  });

  if (typeof swiper != "undefined") {
    swiper.on("click", function () {
      var clicked_index = $(this.clickedSlide).attr("data-swiper-slide-index");
      if ($(this.clickedSlide).next().hasClass("swiper-slide-next")) {
        swiper.slideTo($(this.clickedSlide).index(), 1000, false);
      }
    });
  }

  $("#banner_swiper").on("click", "div.swiper-slide-active img", function (e) {
    if ($(this).attr("enabled") == "yes") {
      window.open($(this).attr("hrf"));
    }
  });

  //new code
  //fade out video text on load Complexity Page
  jQuery(".caption").fadeOut();

  function isInView(elem) {
    if (!elem || !elem.length) return;
    return (
      jQuery(elem).offset().top - jQuery(window).scrollTop() <
      jQuery(elem).height()
    );
  }
  jQuery(window).scroll(function () {
    if (isInView(jQuery(".my-vid"))) jQuery(".caption").fadeIn("slow");
  });
  //Homepage Carousel End -->

  var $popupReopenButtonMobile = $("#klaviyo-popup-reopen-button");
  var $popupReopenButtonDesktop = $("#klaviyo-popup-reopen-button-desktop");
  function showReopenButton($button) {
    $button.show();
  }
  function hideReopenButton($button) {
    $button.hide();
  }
  // Function to add the event listener to the close button
  function addCloseButtonListener() {
    $(".klaviyo-close-form").on("click", function () {
      var isMobile = window.innerWidth <= 768; // Adjust breakpoint as needed
      setTimeout(function () {
        if (isMobile) {
          showReopenButton($popupReopenButtonMobile);
          localStorage.setItem("popupReopenButtonMobileVisible", "true");
        } else {
          showReopenButton($popupReopenButtonDesktop);
          localStorage.setItem("popupReopenButtonDesktopVisible", "true");
        }
      }, 500); // Adjust delay if necessary
    });
  }
  // Observe the body for changes
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.addedNodes.length) {
        $(mutation.addedNodes).each(function () {
          if ($(this).find(".klaviyo-close-form").length) {
            addCloseButtonListener();
          }
        });
      }
    });
  });

  // Configuration for the observer
  var config = { childList: true, subtree: true };
  // Start observing the body
  observer.observe(document.body, config);
  // Check local storage for button visibility on page load
  if (localStorage.getItem("popupReopenButtonMobileVisible") === "true") {
    showReopenButton($popupReopenButtonMobile);
  }
  if (localStorage.getItem("popupReopenButtonDesktopVisible") === "true") {
    showReopenButton($popupReopenButtonDesktop);
  }
  // Add event listener to the reopen buttons
  $popupReopenButtonMobile.on("click", function () {
    window._klOnsite.push(["openForm", "UvmQpn"]); // Mobile form ID
    hideReopenButton($popupReopenButtonMobile);
    localStorage.setItem("popupReopenButtonMobileVisible", "false");
  });
  $popupReopenButtonDesktop.on("click", function () {
    window._klOnsite.push(["openForm", "TadeTp"]); // Desktop form ID
    hideReopenButton($popupReopenButtonDesktop);
    localStorage.setItem("popupReopenButtonDesktopVisible", "false");
  });
  // Optionally, hide the buttons when the popup is opened
  $(document).on("klaviyoPopupOpened", function () {
    hideReopenButton($popupReopenButtonMobile);
    hideReopenButton($popupReopenButtonDesktop);
    localStorage.setItem("popupReopenButtonMobileVisible", "false");
    localStorage.setItem("popupReopenButtonDesktopVisible", "false");
  });

  // $('.footer__item--text .footer__item-title').click(function() {
  //  $('.footer__item--text .footer__item-content').toggle();
  //  $(this).find('svg').toggleClass('open');
  // });
  // $('.footer__item--links .footer__item-title').click(function() {
  //  $('.footer__item--links .footer__item-content').toggle();
  //  $(this).find('svg').toggleClass('open');
  // });
  jQuery(".ruler").click(function () {
    var aa = jQuery(this)
      .parents(".product--thumbnails-left")
      .parents()
      .find(
        jQuery(
          "#block-template--16612558831873__product-content-c5cc9fb6-f738-44b6-b0ab-3262737e2006"
        )
      )
      .addClass("active");
    jQuery(this)
      .parents(".product--thumbnails-left")
      .parents()
      .find(
        jQuery(
          "#block-template--16612558831873__product-content-c5cc9fb6-f738-44b6-b0ab-3262737e2006"
        )
      )
      .attr("hidden", false);
    jQuery(this)
      .parents(".product--thumbnails-left")
      .parents()
      .find(
        jQuery(
          "#block-template--16612558831873__product-content-214f353b-265f-48e2-a87c-6550f991196d"
        )
      )
      .attr("hidden", true);
    var bb = jQuery(this)
      .parents(".product--thumbnails-left")
      .parents()
      .find(
        "[aria-controls='block-template--16612558831873__product-content-c5cc9fb6-f738-44b6-b0ab-3262737e2006']"
      )
      .addClass("active")
      .attr("aria-expanded", true);
    jQuery(this)
      .parents(".product--thumbnails-left")
      .parents()
      .find(
        "[aria-controls='block-template--16612558831873__product-content-214f353b-265f-48e2-a87c-6550f991196d']"
      )
      .attr("aria-expanded", false);
    console.log(bb);
    if (window.matchMedia("(max-width: 767px)").matches) {
      jQuery(".ruler").attr(
        "href",
        "#block-template--16612558831873__product-content-c5cc9fb6-f738-44b6-b0ab-3262737e2006"
      );
    }
    jQuery(this)
      .parents(".product--thumbnails-left")
      .parents()
      .find(
        jQuery(
          "#block-template--16612558831873__product-content-214f353b-265f-48e2-a87c-6550f991196d-content"
        )
      )
      .attr("hidden", true);
    jQuery(this)
      .parents(".product--thumbnails-left")
      .parents()
      .find(
        "[aria-controls='block-template--16612558831873__product-content-c5cc9fb6-f738-44b6-b0ab-3262737e2006-content']"
      )
      .addClass("active")
      .attr("aria-expanded", true);
    jQuery(this)
      .parents(".product--thumbnails-left")
      .parents()
      .find(
        "[aria-controls='block-template--16612558831873__product-content-214f353b-265f-48e2-a87c-6550f991196d-content']"
      )
      .attr("aria-expanded", false);
    jQuery(this)
      .parents(".product--thumbnails-left")
      .parents()
      .find(jQuery(".tabs-nav__scroller-inner"))
      .addClass("hideScroll");
  });
  jQuery(".tabs-nav__scroller-inner .tabs-nav__item-list button").click(
    function () {
      jQuery(this)
        .parents(".tabs-nav__scroller-inner")
        .removeClass("hideScroll");
      jQuery(
        ".tabs-nav__scroller-inner .tabs-nav__item-list button"
      ).removeClass("active");
    }
  );

  $(".accordion-single-item h2.js-acc-single-trigger").click(function () {
    $(this).siblings(".accordion-single-content").slideToggle();
    $(this).toggleClass("active");
  });

  var swiper = new Swiper(".home_collection_list_swiper", {
    slidesPerView: 1.35,
    slideToClickedSlide: true,
    grabCursor: true,
    // spaceBetween: 8,
    loop: false,
    breakpoints: {
      1024: {
        slidesPerView: 3,
        // spaceBetween: 16,
      },
    },
    pagination: {
      el: ".swiper-pagination",
    },
    scrollbar: {
      el: ".home_collection_list_swiper .swiper-scrollbar",
      hide: false,
      draggable: true,
    },
  });

  if ($(window).width() < 768) {
    $(".footer__item-title").click(function () {
      $(this).siblings().slideToggle();
      $(this).toggleClass("active");
    });
  }

  $(".shopify-section--image-with-text #cb1").on("change", function () {
    if (this.checked) {
      $(".sun-light").removeClass("active");
      $(".sun-gold").addClass("active");
      $(".moon-gold").removeClass("active");
      $(".moon-light").addClass("active");
      $(".image-with-text").removeClass("night");
      $(".image-with-text").addClass("day");
    } else {
      $(".sun-light").addClass("active");
      $(".sun-gold").removeClass("active");
      $(".moon-gold").addClass("active");
      $(".moon-light").removeClass("active");
      $(".image-with-text").removeClass("day");
      $(".image-with-text").addClass("night");
    }
  });

  lazyVideoslazyVideos();
  initSlideshowVideoSync();
  injectScriptsAfterInteraction();
});

$(window).on("load", function () {
  const productContentAnchors = Array.prototype.slice.call(
    document.querySelectorAll(".product-content.anchor")
  );

  if (!productContentAnchors.length) {
    return;
  }

  let isTicking = false;

  const updateFeaturedImagesPosition = () => {
    const isSmallViewport =
      window.innerWidth < 480 || window.innerHeight < 480;
    const leftOffset = isSmallViewport ? -100 : 400;
    const rightOffset = isSmallViewport ? 200 : 300;
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    productContentAnchors.forEach((anchor) => {
      const elementTop = anchor.getBoundingClientRect().top + scrollTop;
      const leftImage = anchor.querySelector(".featured_image:first-child");
      const rightImage = anchor.querySelector(".featured_image:nth-child(2)");
      const leftPosition = Math.min(scrollTop - elementTop + leftOffset, 0);
      const rightPosition = Math.min(scrollTop - elementTop + rightOffset, 0);

      if (leftImage) {
        leftImage.style.left = leftPosition + "px";
      }

      if (rightImage) {
        rightImage.style.right = rightPosition + "px";
      }
    });

    isTicking = false;
  };

  const requestPositionUpdate = () => {
    if (isTicking) {
      return;
    }

    isTicking = true;
    window.requestAnimationFrame(updateFeaturedImagesPosition);
  };

  window.addEventListener("scroll", requestPositionUpdate, { passive: true });
  window.addEventListener("resize", requestPositionUpdate);
  requestPositionUpdate();
});

})(window.jQuery);

function productrecommendations() {
  var swiper_slider = new Swiper(".product_recommendation_slider", {
    slidesPerView: 1.4,
    grabCursor: true,
    spaceBetween: 8,
    breakpoints: {
      768: {
        slidesPerView: 2,
        slidesPerGroup: 1,
      },
      1024: {
        spaceBetween: 16,
        slidesPerView: 3,
        slidesPerGroup: 1,
      },
    },
  });
  var swiper_slider = new Swiper(".template__name_diplomat .product_recommendation_slider", {
    slidesPerView: 1.4,
    grabCursor: true,
    spaceBetween: 8,
    breakpoints: {
      768: {
        slidesPerView: 3,
        slidesPerGroup: 1,
        spaceBetween: 24,
      },
      1024: {
        spaceBetween: 16,
        slidesPerView: 3,
        slidesPerGroup: 1,
      },
    },
  });
}

function loadLazyVideo(videoElement) {
  if (!videoElement || !videoElement.classList.contains("vid-lazyload")) {
    return;
  }

  var hasLazySource = false;

  Array.prototype.forEach.call(
    videoElement.querySelectorAll("source[data-src]"),
    function (videoSource) {
      hasLazySource = true;
      videoSource.src = videoSource.dataset.src;
      videoSource.removeAttribute("data-src");
    }
  );

  if (hasLazySource) {
    videoElement.load();
  }

  videoElement.classList.remove("vid-lazyload");
}

function playVideoSafely(videoElement) {
  if (!videoElement) {
    return;
  }

  videoElement.muted = true;
  videoElement.setAttribute("muted", "");
  videoElement.setAttribute("playsinline", "");

  if (videoElement.closest("slide-show-item")) {
    videoElement.style.visibility = "visible";
  }

  var playPromise = videoElement.play();

  if (playPromise && typeof playPromise.catch === "function") {
    playPromise.catch(function () {
      var retryPlayback = function () {
        videoElement.removeEventListener("canplay", retryPlayback);
        videoElement.removeEventListener("loadeddata", retryPlayback);

        var retryPromise = videoElement.play();
        if (retryPromise && typeof retryPromise.catch === "function") {
          retryPromise.catch(function () {});
        }
      };

      videoElement.addEventListener("canplay", retryPlayback, { once: true });
      videoElement.addEventListener("loadeddata", retryPlayback, { once: true });
    });
  }
}

function isElementMostlyVisible(element, thresholdRatio) {
  if (!element || !element.getBoundingClientRect) {
    return false;
  }

  var ratio = thresholdRatio || 0.2;
  var rect = element.getBoundingClientRect();

  if (rect.width === 0 || rect.height === 0) {
    return false;
  }

  var visibleWidth = Math.min(rect.right, window.innerWidth) - Math.max(rect.left, 0);
  var visibleHeight = Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0);

  return visibleWidth > rect.width * ratio && visibleHeight > rect.height * ratio;
}

function syncSlideshowVideos(slideshowElement) {
  if (!slideshowElement) {
    return;
  }

  Array.prototype.forEach.call(
    slideshowElement.querySelectorAll("slide-show-item video"),
    function (videoElement) {
      var slideItem = videoElement.closest("slide-show-item");
      var isActiveSlide = slideItem && !slideItem.hasAttribute("hidden");

      if (isActiveSlide && isElementMostlyVisible(videoElement, 0.2)) {
        loadLazyVideo(videoElement);
        playVideoSafely(videoElement);
      } else {
        videoElement.pause();
        videoElement.style.visibility = "hidden";
      }
    }
  );
}

function initSlideshowVideoSync() {
  if (!("MutationObserver" in window)) {
    return;
  }

  Array.prototype.forEach.call(document.querySelectorAll("slide-show"), function (slideshowElement) {
    if (slideshowElement.dataset.videoSyncInitialized === "true") {
      return;
    }

    slideshowElement.dataset.videoSyncInitialized = "true";

    var scheduleSync = function () {
      window.requestAnimationFrame(function () {
        syncSlideshowVideos(slideshowElement);
      });
    };

    var slideObserver = new MutationObserver(scheduleSync);

    Array.prototype.forEach.call(
      slideshowElement.querySelectorAll("slide-show-item"),
      function (slideItem) {
        slideObserver.observe(slideItem, {
          attributes: true,
          attributeFilter: ["hidden"],
        });
      }
    );

    slideshowElement.addEventListener("page-dots:changed", function () {
      window.setTimeout(scheduleSync, 0);
    });

    window.addEventListener("resize", scheduleSync);
    window.addEventListener("scroll", scheduleSync, { passive: true });

    scheduleSync();
  });
}

function lazyVideoslazyVideos() {
  var lazyVideos = [].slice.call(document.querySelectorAll(".vid-lazyload"));
  if (!lazyVideos.length) return;
  if ("IntersectionObserver" in window) {
    var lazyVideoObserver = new IntersectionObserver(
      function (entries, observer) {
        entries.forEach(function (video) {
          var slideItem = video.target.closest("slide-show-item");
          var isActiveSlide = !slideItem || !slideItem.hasAttribute("hidden");

          if (video.isIntersecting && video.intersectionRatio >= 0.2 && isActiveSlide) {
            loadLazyVideo(video.target);
            playVideoSafely(video.target);
            return;
          } else {
            video.target.pause();
          }
        });
      },
      {
        threshold: [0.0, 0.2],
      }
    );
    lazyVideos.forEach(function (lazyVideo) {
      lazyVideoObserver.observe(lazyVideo);
    });
  }
}

function injectScriptsAfterInteraction() {
  let scriptUrls = [
    `https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=TnfWPc`,
    `https://cdn.506.io/eg/script.js?shop=swan-edgar.myshopify.com`,
    `https://cdn-widgetsrepository.yotpo.com/v1/loader/JZ87rN8Ey7XwUrarEV1qOD79KAtKRcjTt8dgdI0a?languageCode=en`,
    `https://cdn.506.io/cd/cart-drawer.js?shop=swan-edgar.myshopify.com`,
    `https://cdn.shopify.com/extensions/de388b0c-47f2-47fe-b27b-c7d01015cf97/proof-bear-sales-popup-2/assets/salespop-widget.js`,
  ];
  const injectScripts = (urls) => {
    if (!scriptUrls.length) return;
    urls.forEach((scriptUrl) => {
      const script = document.createElement("script");
      script.type = "text/javascript";
      script.async = true;
      script.src = scriptUrl.replaceAll("\\/", "/").replaceAll("\\u0026", "&");
      document.head.appendChild(script);
    });
    scriptUrls.length = 0;
  };

  const loadExternalApps = () => injectScripts(scriptUrls);

  if (window.SwanPerf && typeof window.SwanPerf.afterInteraction === "function") {
    window.SwanPerf.afterInteraction(loadExternalApps);
    return;
  }

  window.addEventListener(
    "load",
    function () {
      window.setTimeout(loadExternalApps, 2000);
    },
    { once: true }
  );
}

// Get the button
let scrollToTopBtn = document.getElementById("scrollToTopBtn");

// Show button when scrolling down 100px from the top of the document
if (scrollToTopBtn) {
  let scrollButtonTicking = false;

  const toggleScrollButton = () => {
    const isVisible =
      document.body.scrollTop > 100 ||
      document.documentElement.scrollTop > 100;

    scrollToTopBtn.classList.toggle("show", isVisible);
    scrollButtonTicking = false;
  };

  window.addEventListener(
    "scroll",
    function () {
      if (scrollButtonTicking) {
        return;
      }

      scrollButtonTicking = true;
      window.requestAnimationFrame(toggleScrollButton);
    },
    { passive: true }
  );

  toggleScrollButton();
}

// Scroll to the top of the document when the button is clicked
if (scrollToTopBtn) {
  scrollToTopBtn.onclick = function () {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
}

// Sticky Banner
// document.addEventListener("scroll", function() {
//     const announcementBar = document.querySelector(".announcement-bar");
//     const stickyOffset = 0; // Distance from top in pixels

//     if (window.scrollY > stickyOffset) {
//         announcementBar.style.position = "fixed";
//         announcementBar.style.top = "0";
//         announcementBar.style.zIndex = "1000"; // Ensure it's on top
//       announcementBar.style.width = "100%";
//     } else {
//         announcementBar.style.position = "static";
//     }
// });

// Rich text klaviyo
const richTextKlaviyo = document.querySelector(".shopify-section--rich-text-klaviyo") || document.querySelector(".shopify-section--rich-text-klaviyo-2");
if (richTextKlaviyo) {
  const klaviyoForm = richTextKlaviyo.querySelector(".klaviyo-form");
  const reminderButtonWrap = richTextKlaviyo.querySelector(".reminder__button-wrap");
  const reminderButton = reminderButtonWrap.querySelector("button");
  const reminderReminderSet = richTextKlaviyo.querySelector(".reminder__reminder-set");
  const klaviyoTextContent = richTextKlaviyo.querySelector(".rich-text-klaviyo__text-content"); // just for section rich-text-klaviyo-2
  const contentBox = richTextKlaviyo.querySelector(".content-box");
  let counterRadioClick = 0;
  let counterSecondStep = 0;
  let klaviyoInput;

  function secondStep() {
    klaviyoForm.classList.add("hidden");
    reminderButtonWrap.classList.remove("hidden");
    klaviyoTextContent ? klaviyoTextContent.remove() : null
    contentBox.classList.add("step--second");
    reminderButton.addEventListener("click", ()=>{
      thirdStep();
      openCalendar();
    })
  }

  function thirdStep() {
    reminderButtonWrap.classList.add("hidden");
    reminderReminderSet.classList.remove("hidden");
  }

  if (klaviyoForm) {
    const observer = new MutationObserver((mutationsList) => {
      mutationsList.forEach((mutation) => {
        if (mutation.type === 'childList') {
          const successMessage = klaviyoForm.querySelector('span');
          if ( successMessage && successMessage.textContent === 'Thank You' || successMessage && successMessage.textContent === 'Thanks for subscribing!' ) {
            secondStep();
            observer.disconnect();
          }
          const klaviyoRadioButton = klaviyoForm.querySelector('[role="radiogroup"] label');
          if (klaviyoRadioButton && counterRadioClick === 0) {
            // klaviyoRadioButton.click();
            counterRadioClick++;
            observeRarioButton(klaviyoRadioButton)
          }
          if (klaviyoInput === undefined ) {
            klaviyoInput = klaviyoForm.querySelector('input[type="email"]');
            listenerInput();
          }
        }
      });
    });
    const config = { childList: true, subtree: true };
    observer.observe(klaviyoForm, config);
  }


  // stop scroling when we have autoclick on radiobutton
  function observeRarioButton(klaviyoRadioButton) {
    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          klaviyoRadioButton.click();
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.99
    });

    if (klaviyoRadioButton) {
      observer.observe(klaviyoRadioButton);
    }
  }
  // end stop scroling when we have autoclick on radiobutton

  function openCalendar() {
    const title = reminderButtonWrap.getAttribute("data-calendar-title");
    const dateTime = reminderButtonWrap.getAttribute("data-calendar");
    let mailSystem = richTextKlaviyo.getAttribute("data-mail-system");
    const domainsOutlook = ["hotmail.com.ar", "live.com.ar", "hotmail.com.au", "live.com.au", "live.at", "hotmail.be", "live.be", "hotmail.com.br", "live.com", "hotmail.ca", "live.ca", "hotmail.cl", "live.cl", "live.com", "live.cn", "hotmail.cz", "windowslive.com", "hotmail.dk", "live.dk", "hotmail.fi", "live.fi", "hotmail.fr", "live.fr", "hotmail.gr", "windowslive.com", "hotmail.de", "live.de", "hotmail.com.hk", "live.hk", "hotmail.hu", "windowslive.com", "hotmail.co.in", "live.in", "hotmail.co.id", "windowslive.com", "live.ie", "hotmail.co.il", "windowslive.com", "live.it", "hotmail.it", "live.jp", "hotmail.co.jp", "hotmail.co.kr", "live.co.kr", "hotmail.lv", "windowslive.com", "hotmail.lt", "windowslive.com", "hotmail.my", "live.com.my", "live.com.mx", "hotmail.nl", "live.nl", "hotmail.co.nz", "live.com", "live.com.pk", "live.com.pe", "hotmail.ph", "live.com.ph", "live.com.pt", "live.ru", "hotmail.rs", "hotmail.sg", "live.com.sg", "hotmail.co.za", "live.co.za", "hotmail.es", "live.com", "hotmail.se", "live.se", "live.com", "hotmail.ch", "windowslive.com", "hotmail.com.tw", "livemail.tw", "hotmail.co.th", "windowslive.com", "hotmail.com.tr", "windowslive.com", "live.co.uk", "hotmail.co.uk", "live.com", "hotmail.com.vn", "windowslive.com", "outlook.co.uk", "outlook.com.ar", "outlook.com.au", "outlook.at", "outlook.be", "outlook.com.br", "outlook.cl", "outlook.cz", "outlook.dk", "outlook.fr", "outlook.de", "outlook.com.gr", "outlook.co.il", "outlook.in", "outlook.co.id", "outlook.ie", "outlook.it", "outlook.hu", "outlook.jp", "outlook.kr", "outlook.lv", "outlook.my", "outlook.co.nz", "outlook.com.pe", "outlook.ph", "outlook.pt", "outlook.sa", "outlook.sg", "outlook.sk", "outlook.es", "outlook.co.th", "outlook.com.tr", "outlook.com.vn"];

    domainsOutlook.some(domain => {
      if (domain.includes(mailSystem)) {
        console.log("domain: ", domain);
        mailSystem = "outlook.com";
        return true;
      }
    });

    if (!dateTime) {
      alert("The date and time of the event are not specified");
      return;
    }

    const dateParts = dateTime.split(' ')[0].split('-');
    const timeParts = dateTime.split(' ')[1].split(':');

    if (!dateParts || !timeParts || dateParts.length !== 3 || timeParts.length !== 2) {
      alert("Invalid date and time format. Use the format: YYYY-MM-DD HH:MM.");
      return;
    }

    const year = dateParts[0];
    const month = dateParts[1].padStart(2, '0');
    const day = dateParts[2].padStart(2, '0');
    const hour = timeParts[0].padStart(2, '0');
    const minute = timeParts[1].padStart(2, '0');
    const formattedDate = `${year}${month}${day}T${hour}${minute}00`;

    function formatDateOutlook(input) {
      let year = input.slice(0, 4);
      let month = input.slice(4, 6);
      let day = input.slice(6, 8);
      let hour = input.slice(9, 11);
      let minute = input.slice(11, 13);
      let second = input.slice(13, 15);
      return `${year}-${month}-${day}T${hour}:${minute}:${second}`;
    }

    let calendarURL = "";

    switch(mailSystem) {
      case "gmail.com":
        calendarURL = `https://www.google.com/calendar/render?action=TEMPLATE&text=${encodeURIComponent(title)}&dates=${formattedDate}/${formattedDate}&details=&location=&sf=true&ctz=Europe/London&output=xml`;
        break;
      case "outlook.com":
        calendarURL = `https://outlook.live.com/calendar/0/deeplink/compose?path=/calendar/action/compose&rru=addevent&startdt=${formatDateOutlook(formattedDate)}&enddt=${formatDateOutlook(formattedDate)}&subject=${encodeURIComponent(title)}&starttz=Europe/London&endtz=Europe/London`;
        break;
      default:
        calendarURL = `https://www.google.com/calendar/render?action=TEMPLATE&text=${encodeURIComponent(title)}&dates=${formattedDate}/${formattedDate}&details=&location=&sf=true&ctz=Europe/London&output=xml`;
        break;
    }
    if ( counterSecondStep === 0) {
      ++counterSecondStep
      window.open(calendarURL, '_blank');
    }
  }
  function listenerInput() {
    function extractDomain(email) {
      const domain = email.split('@')[1];
      return domain ? domain : '';
    }

    klaviyoInput.addEventListener('input', function () {
      const emailValue = klaviyoInput.value;
      const domain = extractDomain(emailValue);
      if (domain) {
        richTextKlaviyo.setAttribute('data-mail-system', domain);
      } else {
        richTextKlaviyo.removeAttribute('data-mail-system');
      }
    });
  }
}


// Rich text klaviyo sticky
const richTextKlaviyoSticky = document.querySelector(".section-sticky-klavio, .product-sticky-form, .sticky-prelaunch-waitlist-form-wrapper");
if (richTextKlaviyoSticky) {
  const klaviyoForm = richTextKlaviyoSticky.querySelector(".klaviyo-form");
  const reminderButtonWrap = richTextKlaviyoSticky.querySelector(".reminder__button-wrap");

  const reminderButton = reminderButtonWrap?.querySelector("button");
  const reminderReminderSet = richTextKlaviyoSticky.querySelector(".reminder__reminder-set");
  const klaviyoTextContent = richTextKlaviyoSticky.querySelector(".rich-text-klaviyo__text-content"); // just for section rich-text-klaviyo-2
  // const contentBox = richTextKlaviyoSticky.querySelector(".sticky-klavio__container");
  const contentBox = richTextKlaviyoSticky;
  let counterSecondStep = 0;
  let klaviyoInput;

  function secondStep() {
    klaviyoForm.classList.add("hidden");
    reminderButtonWrap.classList.remove("hidden");
    klaviyoTextContent ? klaviyoTextContent.remove() : null
    contentBox.classList.add("step--second");
    reminderButton.addEventListener("click", ()=>{
      thirdStep();
      openCalendar();
    })
  }

  function thirdStep() {
    reminderButtonWrap.classList.add("hidden");
    reminderReminderSet.classList.remove("hidden");
  }

  if (klaviyoForm) {
    const observer = new MutationObserver((mutationsList) => {
      mutationsList.forEach((mutation) => {
        if (mutation.type === 'childList') {
          const successMessage = klaviyoForm.querySelector('span');
          if ( successMessage && successMessage.textContent === 'Thank You' || successMessage && successMessage.textContent === 'Thanks for subscribing!' || successMessage && successMessage.textContent === 'Check your email for a confirmation message.' ) {
            secondStep();
            observer.disconnect();
          }
          if (klaviyoInput === undefined ) {
            klaviyoInput = klaviyoForm.querySelector('input[type="email"]');
            listenerInput();
          }
        }
      });
    });
    const config = { childList: true, subtree: true };
    observer.observe(klaviyoForm, config);
  }

  function openCalendar() {
    const title = reminderButtonWrap.getAttribute("data-calendar-title");
    const dateTime = reminderButtonWrap.getAttribute("data-calendar");
    let mailSystem = richTextKlaviyoSticky.getAttribute("data-mail-system");
    const domainsOutlook = ["hotmail.com.ar", "live.com.ar", "hotmail.com.au", "live.com.au", "live.at", "hotmail.be", "live.be", "hotmail.com.br", "live.com", "hotmail.ca", "live.ca", "hotmail.cl", "live.cl", "live.com", "live.cn", "hotmail.cz", "windowslive.com", "hotmail.dk", "live.dk", "hotmail.fi", "live.fi", "hotmail.fr", "live.fr", "hotmail.gr", "windowslive.com", "hotmail.de", "live.de", "hotmail.com.hk", "live.hk", "hotmail.hu", "windowslive.com", "hotmail.co.in", "live.in", "hotmail.co.id", "windowslive.com", "live.ie", "hotmail.co.il", "windowslive.com", "live.it", "hotmail.it", "live.jp", "hotmail.co.jp", "hotmail.co.kr", "live.co.kr", "hotmail.lv", "windowslive.com", "hotmail.lt", "windowslive.com", "hotmail.my", "live.com.my", "live.com.mx", "hotmail.nl", "live.nl", "hotmail.co.nz", "live.com", "live.com.pk", "live.com.pe", "hotmail.ph", "live.com.ph", "live.com.pt", "live.ru", "hotmail.rs", "hotmail.sg", "live.com.sg", "hotmail.co.za", "live.co.za", "hotmail.es", "live.com", "hotmail.se", "live.se", "live.com", "hotmail.ch", "windowslive.com", "hotmail.com.tw", "livemail.tw", "hotmail.co.th", "windowslive.com", "hotmail.com.tr", "windowslive.com", "live.co.uk", "hotmail.co.uk", "live.com", "hotmail.com.vn", "windowslive.com", "outlook.co.uk", "outlook.com.ar", "outlook.com.au", "outlook.at", "outlook.be", "outlook.com.br", "outlook.cl", "outlook.cz", "outlook.dk", "outlook.fr", "outlook.de", "outlook.com.gr", "outlook.co.il", "outlook.in", "outlook.co.id", "outlook.ie", "outlook.it", "outlook.hu", "outlook.jp", "outlook.kr", "outlook.lv", "outlook.my", "outlook.co.nz", "outlook.com.pe", "outlook.ph", "outlook.pt", "outlook.sa", "outlook.sg", "outlook.sk", "outlook.es", "outlook.co.th", "outlook.com.tr", "outlook.com.vn"];

    domainsOutlook.some(domain => {
      if (domain.includes(mailSystem)) {
        console.log("domain: ", domain);
        mailSystem = "outlook.com";
        return true;
      }
    });

    if (!dateTime) {
      alert("The date and time of the event are not specified");
      return;
    }

    const dateParts = dateTime.split(' ')[0].split('-');
    const timeParts = dateTime.split(' ')[1].split(':');

    if (!dateParts || !timeParts || dateParts.length !== 3 || timeParts.length !== 2) {
      alert("Invalid date and time format. Use the format: YYYY-MM-DD HH:MM.");
      return;
    }

    const year = dateParts[0];
    const month = dateParts[1].padStart(2, '0');
    const day = dateParts[2].padStart(2, '0');
    const hour = timeParts[0].padStart(2, '0');
    const minute = timeParts[1].padStart(2, '0');
    const formattedDate = `${year}${month}${day}T${hour}${minute}00`;

    function formatDateOutlook(input) {
      let year = input.slice(0, 4);
      let month = input.slice(4, 6);
      let day = input.slice(6, 8);
      let hour = input.slice(9, 11);
      let minute = input.slice(11, 13);
      let second = input.slice(13, 15);
      return `${year}-${month}-${day}T${hour}:${minute}:${second}`;
    }

    let calendarURL = "";

    switch(mailSystem) {
      case "gmail.com":
        calendarURL = `https://www.google.com/calendar/render?action=TEMPLATE&text=${encodeURIComponent(title)}&dates=${formattedDate}/${formattedDate}&details=&location=&sf=true&ctz=Europe/London&output=xml`;
        break;
      case "outlook.com":
        calendarURL = `https://outlook.live.com/calendar/0/deeplink/compose?path=/calendar/action/compose&rru=addevent&startdt=${formatDateOutlook(formattedDate)}&enddt=${formatDateOutlook(formattedDate)}&subject=${encodeURIComponent(title)}&starttz=Europe/London&endtz=Europe/London`;
        break;
      default:
        calendarURL = `https://www.google.com/calendar/render?action=TEMPLATE&text=${encodeURIComponent(title)}&dates=${formattedDate}/${formattedDate}&details=&location=&sf=true&ctz=Europe/London&output=xml`;
        break;
    }
    if ( counterSecondStep === 0) {
      ++counterSecondStep
      window.open(calendarURL, '_blank');
    }
  }
  function listenerInput() {
    function extractDomain(email) {
      const domain = email.split('@')[1];
      return domain ? domain : '';
    }

    klaviyoInput.addEventListener('input', function () {
      const emailValue = klaviyoInput.value;
      const domain = extractDomain(emailValue);
      if (domain) {
        richTextKlaviyoSticky.setAttribute('data-mail-system', domain);
      } else {
        richTextKlaviyoSticky.removeAttribute('data-mail-system');
      }
    });
  }
}


// button Read more in section image-with-text-horizon
document.addEventListener('DOMContentLoaded', () => {
  const MAX_WIDTH = 1200;
  let isInitialized = false;
  let cleanupFunctions = [];

  const initialize = () => {
    const buttons = document.querySelectorAll('.image-with-text__read-more-button');

    buttons.forEach(button => {
      const content = button.closest('.image-with-text__content');
      const textWrapper = content?.querySelector('.image-with-text__text-wrapper');
      if (!textWrapper) return;

      const paragraphs = Array.from(textWrapper.querySelectorAll('p'));

      if (paragraphs.length <= 1) {
        button.remove();
      }
      if (paragraphs.length <= 1) return;

      const showMoreText = button.textContent.trim();
      const showLessText = button.dataset.showLess || 'Hide';

      paragraphs.forEach((p, index) => {
        if (index > 0) {
          p.style.maxHeight = '0';
          p.style.overflow = 'hidden';
        }
      });

      let expanded = false;

      const toggle = () => {
        expanded = !expanded;
        paragraphs.forEach((p, index) => {
          if (index === 0) return;

          if (expanded) {
            p.style.maxHeight = p.scrollHeight + 'px';
            textWrapper.classList.add("open");
          } else {
            p.style.maxHeight = '0';
            textWrapper.classList.remove("open");
          }
        });
        button.textContent = expanded ? showLessText : showMoreText;
      };

      button.addEventListener('click', toggle);

      cleanupFunctions.push(() => {
        button.removeEventListener('click', toggle);
        paragraphs.forEach(p => {
          p.style.maxHeight = '';
          p.style.overflow = '';
        });
        button.textContent = showMoreText;
      });
    });

    isInitialized = true;
  };

  const cleanup = () => {
    cleanupFunctions.forEach(fn => fn());
    cleanupFunctions = [];
    isInitialized = false;
  };

  const handleResize = () => {
    if (window.innerWidth < MAX_WIDTH && !isInitialized) {
      initialize();
    } else if (window.innerWidth >= MAX_WIDTH && isInitialized) {
      cleanup();
    }
  };

  handleResize();

  window.addEventListener('resize', handleResize);
});


// timer-countdown section
const timers = document.querySelectorAll(".timer-countdown .timer__clock-face.unactive");
timers.forEach(timer => {
  timer.classList.remove("unactive");
  let daysSpan = timer.querySelector(".days");
  let hoursSpan = timer.querySelector(".hours");
  let minutesSpan = timer.querySelector(".minutes");
  let secondsSpan = timer.querySelector(".seconds");


  const section = timer.closest(".shopify-section--timer-countdown");

  let timerCountdownDate = timer.getAttribute("data-countdown-date");

  let endtimePlaceDays = 0;
  let endtimePlaceHours = 0;
  let endtimePlaceMinutes = 0;
  if (timer.getAttribute("data-timer-days")) {
    endtimePlaceDays = Number(timer.getAttribute("data-timer-days"));
  }
  if (timer.getAttribute("data-timer-hours")) {
    endtimePlaceHours = Number(timer.getAttribute("data-timer-hours"));
  }
  if (timer.getAttribute("data-timer-minutes")) {
    endtimePlaceMinutes = Number(timer.getAttribute("data-timer-minutes"));
  }

  let endtime = new Date(timerCountdownDate*1000);

  let timeinterval = setInterval(updateClock,1000);

  updateClock();

  function updateClock(){
    let t = getTimeRemaining(endtime);

    if (daysSpan) {
      update(daysSpan, t.days);
    }
    if (hoursSpan) {
      update(hoursSpan, t.hours);
    }
    if (minutesSpan) {
      update(minutesSpan, t.minutes);
    }
    if (secondsSpan) {
      update(secondsSpan, t.seconds);
    }
    if(t.total<=0){
      clearInterval(timeinterval);

      setTimeout(() => {
        if (section) {
          section.remove();
        }
      }, 100);
    }
  }

  function update(place, time) {
    if (time < 10 ) {
      time = "0" + time;
    }
    let number = place.querySelector(".card__number");
    number.innerText = time;
  }

  function getTimeRemaining(endtime){
    let t = Date.parse(endtime) - Date.parse(new Date());
    let seconds = Math.floor( (t/1000) % 60 );
    let minutes = Math.floor( (t/1000/60) % 60 );
    let hours = Math.floor( (t/(1000*60*60)) % 24 );
    let days = Math.floor( t/(1000*60*60*24) );
    return {
    "total": t,
    "days": days,
    "hours": hours,
    "minutes": minutes,
    "seconds": seconds
    };
  }
});



function initReadMore(options = {}) {
  const defaults = {
    containerSelector: '.text-read-more-container',
    contentSelector: '.text-read-more',
    buttonSelector: '.text-read-more-button',
    mobileBreakpoint: 767,
    initialParagraphs: 2
  };

  const settings = { ...defaults, ...options };

  const containers = document.querySelectorAll(settings.containerSelector);

  containers.forEach(container => {
    const content = container.querySelector(settings.contentSelector);
    const button = container.querySelector(settings.buttonSelector);
    const paragraphs = content.querySelectorAll('p');

    function handleReadMore() {
      // Only apply on mobile if window width is less than breakpoint
      if (window.innerWidth <= settings.mobileBreakpoint) {
        if(paragraphs.length <= settings.initialParagraphs){
          button.style.display = 'none';
          return
        }
        // Set initial styles for animation
        paragraphs.forEach((p, index) => {
          p.style.overflow = 'hidden';

          if (index < settings.initialParagraphs) {
            p.style.maxHeight = p.scrollHeight + 'px';
          } else {
            p.style.maxHeight = '0';
            p.style.margin = '0';
          }
        });

        button.style.display = 'block';
        button.textContent = (button.dataset.showMore || 'Read more');

        let isExpanded = false;

        // Remove previous event listener if exists
        button.removeEventListener('click', button.clickHandler);

        // Create new click handler
        button.clickHandler = () => {
          isExpanded = !isExpanded;

          paragraphs.forEach((p, index) => {
            if (index >= settings.initialParagraphs) {
              // p.style.maxHeight = isExpanded ? p.scrollHeight + 'px' : '0';
              if (p.style.maxHeight = isExpanded) {
                p.style.marginBlockStart = "1em";
                p.style.maxHeight = p.scrollHeight + 'px';
              } else {
                p.style.maxHeight = '0';
                p.style.marginBlockStart = "0";
              }
              console.log(p);
            }
          });

          // button.textContent = isExpanded ?
          //     (button.dataset.showLess || 'Show less') :
          //     (button.dataset.showMore || 'Read more');

          if (button.textContent = isExpanded) {
            button.textContent = button.dataset.showLess || 'Show less';
            button.style.marginTop = "12px"
          } else {
            button.textContent = button.dataset.showMore || 'Read more';
            button.style.marginTop = "0px"
          }
        };

        button.addEventListener('click', button.clickHandler);
      } else {
        // Reset styles for desktop
        paragraphs.forEach(p => {
          p.style.maxHeight = 'none';
          p.style.overflow = 'visible';
          p.style.margin = '';
        });
        button.style.display = 'none';
      }
    }

    // Initial setup
    handleReadMore();

    // Update on resize
    window.addEventListener('resize', handleReadMore);
  });
}

function initReadMoreBlocks(){
  const readMoreBlocks = [
    {
      containerSelector: '.text-read-more-container',
      contentSelector: '.text-read-more',
      buttonSelector: '.text-read-more-button',
      mobileBreakpoint: 767,
      initialParagraphs: 2
    },
    {
      containerSelector: '.product-image-with-text-content',
      contentSelector: '.product-image-with-text-content-text',
      buttonSelector: '.product-image-with-text-content-more-button',
      mobileBreakpoint: 767,
      initialParagraphs: 2
    }
  ]
  readMoreBlocks.forEach(options=> initReadMore(options));
}
initReadMoreBlocks();


// tabs switcher .shopify-section--tabs
const tabsSection = document.querySelector(".shopify-section--tabs");
if (tabsSection) {
    let titles = tabsSection.querySelectorAll(".tabs__title");
    let contents = tabsSection.querySelectorAll(".tabs__content");
    titles.forEach((title, indexTitle) => {
    contents.forEach((content, indexContent) => {
      if (indexTitle === indexContent) {
        title.addEventListener("click", ()=>{
          const activeTitle = tabsSection.querySelector(".tabs__title.active");
          const activeContent = tabsSection.querySelector(".tabs__content.active");
          activeTitle.classList.remove("active");
          activeContent.classList.remove("active");
          title.classList.add("active");
          content.classList.add("active");
        })
      }
    });
  });
}


// timelines
const timelinesSection = document.querySelector(".shopify-section--timelines");
if (timelinesSection) {
  const timeline = document.querySelector(".timelines__timeline-content");
  const timelineLine = document.querySelector(".timelines__timeline-line");
  timelineLine.style.width = timeline.scrollWidth + 'px';

  const timelineContent = document.querySelector('.timelines__timeline-content-wrap');
  const buttonsWrap = document.querySelector('.timelines__buttons-wrap');
  const buttonPrev = document.querySelector('.timelines__button--prew');
  const buttonNext = document.querySelector('.timelines__button--next');

  const scrollDistance = 250;

  if (timelineContent.scrollWidth > timelineContent.clientWidth) {
    function scrollContent(direction) {
      let scrollOn = scrollDistance;
      if (direction === 'next') {
          
          if((timelineContent.scrollLeft + scrollDistance) > (timelineContent.scrollWidth - timelineContent.offsetWidth)){
              scrollOn = (timelineContent.scrollWidth - timelineContent.offsetWidth) - timelineContent.scrollLeft;
              buttonNext.classList.add('disabled');
          }else{
              buttonNext.classList.remove('disabled');
          }
          buttonPrev.classList.remove('disabled');
          timelineContent.scrollBy({ left: scrollOn, behavior: 'smooth' });
      } else if (direction === 'prev') {
          if(timelineContent.scrollLeft < scrollDistance){
              scrollOn = scrollDistance - (scrollDistance - timelineContent.scrollLeft)
              buttonPrev.classList.add('disabled');
          }else{
              buttonPrev.classList.remove('disabled');
          }
          buttonNext.classList.remove('disabled');
          
          timelineContent.scrollBy({ left: -scrollOn, behavior: 'smooth' });
      }
      // setTimeout(checkButtonsState, 300);
    }
    function checkButtonsState() {
      if (timelineContent.scrollLeft + timelineContent.clientWidth >= timelineContent.scrollWidth - 10) {
        buttonNext.classList.add('disabled');
        buttonNext.setAttribute("disabled", "");
      } else {
        buttonNext.classList.remove('disabled');
        buttonNext.removeAttribute("disabled");
      }
      if (timelineContent.scrollLeft === 0) {
        buttonPrev.classList.add('disabled');
        buttonNext.setAttribute("disabled", "");
      } else {
        buttonPrev.classList.remove('disabled');
        buttonNext.removeAttribute("disabled");
      }
    }

    buttonNext.addEventListener('click', () => scrollContent('next'));
    buttonPrev.addEventListener('click', () => scrollContent('prev'));

    const onIntersect = (entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          timelineContent.scrollLeft = timelineContent.scrollWidth;
          setTimeout(() => {
            checkButtonsState();
          }, 800);
          observer.unobserve(entry.target);
        }
      });
    };
    const observer = new IntersectionObserver(onIntersect, {
      root: null,
      rootMargin: '0px',
      threshold: 0.85
    });
    if (timelineContent) {
      observer.observe(timelineContent);
    }
  } else {
    buttonsWrap.classList.add('hidden');
  }
}

function initCurrentViewers() {
  const viewerElements = document.querySelectorAll('.js-current-viewers');
  if (!viewerElements.length) return;

  function getRandomViewers() {
    return Math.floor(Math.random() * (10 - 2 + 1)) + 2; // Random number between 2-10
  }

  function setCookie(name, value, minutes) {
    const date = new Date();
    date.setTime(date.getTime() + (minutes * 60 * 1000));
    const expires = `expires=${date.toUTCString()}`;
    document.cookie = `${name}=${value};${expires};path=/`;
  }

  function getCookie(name) {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
  }

  function updateViewerCount() {
    let viewers = getCookie('current_viewers');

    if (!viewers) {
      viewers = getRandomViewers();
      setCookie('current_viewers', viewers, 2); // Store for 10 minutes
    }

    viewerElements.forEach(element => {
      element.textContent = viewers;
    });
  }

  updateViewerCount();

}
initCurrentViewers();




setTimeout(() => {
  function updateCurrentButtonDisplay() {
    const buttons = document.querySelectorAll('.slideshow__nav button');
    const currentButton = document.querySelector('.slideshow__nav button[aria-current="true"]');
    const progressNumbers = document.querySelector('.slideshow__progress-bar-numbers');

    if (currentButton) {
      const currentIndex = Array.from(buttons).indexOf(currentButton) + 1;
      const totalButtons = buttons.length;
      progressNumbers.innerText = `${currentIndex} / ${totalButtons}`;
    }
  }

  const observer = new MutationObserver(() => {
    updateCurrentButtonDisplay();
  });

  if (document.querySelector('.slideshow__nav')) {
    observer.observe(document.querySelector('.slideshow__nav'), {
      childList: true,
      attributes: true,
      subtree: true
    });
  }
  // observer.observe(document.querySelector('.slideshow__nav'), {
  //   childList: true,
  //   attributes: true,
  //   subtree: true
  // });

  updateCurrentButtonDisplay();
}, 500);



if (document.querySelector(".yotpo-widget-instance")) {
  starsRatingCheck();
}
function starsRatingCheck() {
  function waitForElement(selector, callback) {
    const el = document.querySelector(selector);
    if (el) {
      callback(el);
    } else {
      const observer = new MutationObserver((mutations, obs) => {
        const el = document.querySelector(selector);
        if (el) {
          obs.disconnect();
          callback(el);
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }
  }

  waitForElement('.yotpo-widget-instance', (targetNode) => {
    const observer = new MutationObserver((mutationsList) => {
      for (let mutation of mutationsList) {
        if (mutation.type === 'childList') {
          checkRation()
        }
      }
    });

    observer.observe(targetNode, {
      childList: true,
    });
  });

  function checkRation() {
    const widget = document.querySelector('.yotpo-widget-instance');

    if (widget) {
      const bottomLineText = widget.querySelector('.yotpo-sr-bottom-line-text');

      if (bottomLineText) {
        const text = bottomLineText.textContent;
        const match = text.match(/\((\d+)\)/);

        if (match && match[1]) {
          const number = parseInt(match[1], 10);
          // console.log('Reviews:', number);

          if (number == 0) {
            const reviewsItem = document.querySelector('.product-sticky-form__nav__item.item--reviews');
            if (reviewsItem && reviewsItem.parentNode) {
                reviewsItem.parentNode.style.display = "none";
            }

            const yotpoWidget = document.querySelector('.yotpo-widget-instance');
            if (yotpoWidget) {
                yotpoWidget.style.display = "none";
            }
          }
        }
      }
    }
  }
}

// https://swanandedgar.com/apps/product-registration
document.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => {
    const rootElement = document.querySelector('#mpr-root');
    if (!rootElement) return;

    function insertIntoInput(containerSelector, inputSelector) {
        const container = rootElement.querySelector(containerSelector);
        if (!container) return;

        const label = container.querySelector('.mpr-custom-label');
        if (!label) return;

        const labelText = label.innerText.trim();
        if (!labelText) return;

        const input = document.querySelector(inputSelector);
        if (!input) return;

        input.value = labelText;
    }

    function insertIntoElementText(containerSelector, targetSelector) {
        const container = rootElement.querySelector(containerSelector);
        if (!container) return;

        const label = container.querySelector('.mpr-custom-label');
        if (!label) return;

        const labelText = label.innerText.trim();
        if (!labelText) return;

        const target = document.querySelector(targetSelector);
        if (!target) return;

        target.innerText = labelText;
    }
    insertIntoInput('.mpr-class-purchaseDate', '.react-datepicker-wrapper input');
    insertIntoElementText('.mpr-class-country', '.mpr-field-country__single-value');
    insertIntoElementText('.mpr-class-state', '.mpr-field-state__single-value');
  }, 1500);

});



if (document.querySelector(".reviews-block")) {
  const reviewsBlockSwiper = new Swiper(".reviews-block", {
    navigation: {
      nextEl: ".reviews-block .swiper-button-next",
      prevEl: ".reviews-block .swiper-button-prev",
    },
  });
}

document.addEventListener("DOMContentLoaded", function () {
  const reviewsBlock = document.querySelector('.reviews-block');
  if (!reviewsBlock) return;

  const scrollButton = reviewsBlock.querySelector('.reviews-block__scroll-button');
  if (!scrollButton) return;

  const checkForYotpoWidget = () => {
    const yotpoWidget = document.querySelector('#yotpo-reviews-main-widget');
    if (!yotpoWidget) return false;

    const yotpoReviews = yotpoWidget.querySelectorAll('.yotpo-review');
    if (yotpoReviews.length > 0) {
      scrollButton.classList.remove('hidden');
      scrollButton.addEventListener('click', function (e) {
        e.preventDefault();
        yotpoWidget.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }, { once: true });
      return true;
    }

    return false;
  };

  if (!checkForYotpoWidget()) {
    const observer = new MutationObserver(() => {
      if (checkForYotpoWidget()) {
        observer.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
});

function checkSnapshots() {
  const snapshots = document.querySelectorAll('#snapshot');
  snapshots.forEach(element => {
    const computedStyle = window.getComputedStyle(element);
    const elementSave = element.outerHTML;
    window.addEventListener('resize', check);
    check();
    function check() {
      if (computedStyle.display === 'none') {
        element.removeAttribute('id');
      } else {
        element.id = 'snapshot';
      }
    }
  });
}
setTimeout(checkSnapshots, 1000);

// Cart app changes
document.addEventListener("DOMContentLoaded", function () {
  const observer = new MutationObserver(mutations => {
    const cart = document.querySelector('#cart-drawer-app');
    // console.log(mutations);
    if (cart) {
      setTimeout(() => {
        initCartObservers(cart);
      }, 1500);
      setTimeout(() => {
        ratingCart();
      }, 3000);
      setTimeout(() => {
        updateCartAddonsVisibility();
      }, 1600);
      setTimeout(() => {
        syncCartUpsellButtonsState();
      }, 1600);
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  function initCartObservers(cart) {

    const cartBody = cart.querySelector('.cd-cart-body');
    if (!cartBody) {
      return;
    }
    if (cartBody.classList.contains("in-progress")) return;
    cartBody.classList.add("in-progress");


    const discountCodeElement = cart.querySelector('.cd-cart-discount-code');
    const addons = document.querySelector('.cd-cart-addons');

    discountUpdate();
    function discountUpdate() {
      if (!discountCodeElement) return;

      let discountNewCoupon = '';

      const wrapper = document.createElement('div');
      wrapper.classList.add('discount-code-dropdown');

      cart.appendChild(wrapper);

      cartBody.insertBefore(wrapper, discountCodeElement);

      const toggleButton = document.createElement('button');
      toggleButton.classList.add("discount-code-dropdown--open")
      toggleButton.textContent = 'Apply Coupon Code';
      wrapper.appendChild(toggleButton);
      const toggleButtonPlus = document.createElement('button');
      toggleButtonPlus.textContent = '+';
      wrapper.appendChild(toggleButtonPlus);

      discountCodeElement.style.display = 'none';

      toggleButton.addEventListener('click', function() {
        const isVisible = discountCodeElement.style.display === 'block';
        discountCodeElement.style.display = isVisible ? 'none' : 'block';
        toggleButton.textContent = isVisible ? 'Apply Coupon Code' : (discountNewCoupon ? `Coupon ${discountNewCoupon} Applied`: 'Apply Coupon Code');
        toggleButtonPlus.textContent = isVisible ? '+' : '-';
      });

      // let discountTexts = [];
      // let count = 0
      // function updateDiscountTexts() {
      //   setTimeout(() => {
      //     const discountTags = document.querySelectorAll('.cd-cart-discount-tag');
      //     console.log(discountTags);


      //     if (discountTags.length == 0) return;
      //     const newDiscountTexts = Array.from(discountTags).map(tag => tag.textContent.trim());

      //     const addedDiscounts = newDiscountTexts.filter(text => !discountTexts.includes(text));
      //     const removedDiscounts = discountTexts.filter(text => !newDiscountTexts.includes(text));

      //     discountTexts = newDiscountTexts;
      //     console.log("discountTexts: ", discountTexts);
      //     console.log("newDiscountTexts: ", newDiscountTexts);

      //     if (addedDiscounts.length > 0) {
      //       console.log('Updated coupons:', addedDiscounts[0]);
      //       console.log("count: ", count);
      //       if (count >= 1) {
      //         console.log('added new coupons:', addedDiscounts[0]);
      //         discountNewCoupon = addedDiscounts[0];
      //         toggleButton.textContent = `Coupon ${discountNewCoupon} Applied`;
      //       }
      //     }
      //     if (removedDiscounts.length > 0) {
      //       // console.log('Deleted coupon:', removedDiscounts[0]);
      //     }
      //     // console.log('coupons now:', discountTexts);
      //     count++;
      //   }, 1000);
      // }

      // updateDiscountTexts();
      // const observerCart = new MutationObserver(mutations => {
      //   const discountElement = document.querySelector('.cd-cart-discount-details');
      //   if (discountElement) {
      //     observerCart.disconnect();
      //     const childObserver = new MutationObserver(updateDiscountTexts);
      //     childObserver.observe(discountElement, {
      //       childList: true,
      //       subtree: true
      //     });
      //   }
      // });

      // observerCart.observe(document.querySelector('.cd-cart-inner'), {
      //   childList: true,
      //   subtree: true
      // });

    }

    moveGiftBox();

    function moveGiftBox() {
      cartBody.appendChild(addons);
    }

    updateCartAddonsVisibility();

    moveTrustContent();

    function moveTrustContent() {
      const footerInner = cart.querySelector('.cd-cart-footer-inner');
      const contentForCartApp = document.querySelector('.content-for-cart-app');
      const contentForCartAppClone = contentForCartApp.cloneNode(true);
      footerInner.insertBefore(contentForCartAppClone, footerInner.firstChild);
      contentForCartAppClone.style.display = "block";
    }

    moveUpsellProduct();

    function moveUpsellProduct() {
      const upsell = document.querySelector('#cart-upsell-product');
      if (!upsell) return;

      cartBody.appendChild(upsell);
      upsell.style.display = '';

      initCartUpsellSlider(upsell);
      bindCartUpsellAddButtons(upsell);
      syncCartUpsellButtonsState();
    }

  }

  function initCartUpsellSlider(upsell) {
    const sliderEl = upsell.querySelector('.cart-upsell-product__slider');
    if (!sliderEl || sliderEl.classList.contains('swiper-initialized')) return;
    if (typeof Swiper === 'undefined') return;

    let slidesPerView = parseFloat(sliderEl.dataset.slidesPerView);
    if (isNaN(slidesPerView)) slidesPerView = 1.2;

    const prevButton = upsell.querySelector('.coll-slider-hp-arrows__button--prev');
    const nextButton = upsell.querySelector('.coll-slider-hp-arrows__button--next');

    const swiper = new Swiper(sliderEl, {
      slidesPerView: slidesPerView,
      spaceBetween: 16,
      grabCursor: true,
      loop: false
    });

    if (prevButton && nextButton) {
      const refreshArrowsState = function () {
        prevButton.disabled = swiper.isLocked || swiper.isBeginning;
        nextButton.disabled = swiper.isLocked || swiper.isEnd;
      };

      prevButton.addEventListener('click', function () {
        swiper.slidePrev();
      });
      nextButton.addEventListener('click', function () {
        swiper.slideNext();
      });

      swiper.on('slideChange reachBeginning reachEnd fromEdge resize lock unlock', refreshArrowsState);
      refreshArrowsState();
    }
  }

  function bindCartUpsellAddButtons(upsell) {
    upsell.querySelectorAll('[data-cart-upsell-add]').forEach(addButton => {
      if (addButton.dataset.bound) return;
      addButton.dataset.bound = 'true';

      addButton.addEventListener('click', function () {
        const variantId = addButton.getAttribute('data-variant-id');
        if (!variantId || addButton.disabled) return;

        addButton.disabled = true;

        // The Cartix cart-drawer app (cdn.506.io/cd/cart-drawer.js) does not listen for the
        // theme's cart:updated/cart:refresh events. It exposes its own API for exactly this
        // (the same one its native .cd-cart-upsell-item-add buttons call internally), which
        // also updates its internal state and re-renders the drawer without a page reload.
        if (typeof window.CD_ADDTOCART === 'function') {
          Promise.resolve(window.CD_ADDTOCART({ id: variantId, quantity: 1 }, true))
            .catch(error => console.error('Error adding upsell product to cart:', error))
            .finally(() => {
              addButton.disabled = false;
            });
          return;
        }

        fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        })
          .then(() => {
            if (typeof window.CD_REFRESHCART === 'function') {
              return window.CD_REFRESHCART();
            }
          })
          .catch(error => console.error('Error adding upsell product to cart:', error))
          .finally(() => {
            addButton.disabled = false;
          });
      });
    });
  }

  function syncCartUpsellButtonsState() {
    const upsell = document.querySelector('#cart-upsell-product');
    if (!upsell) return;

    const cartVariantIds = Array.from(document.querySelectorAll('.cd-cart-item')).map(item => {
      const removeButton = item.querySelector('.cd-cart-remove-button');
      const cartItemData = removeButton ? removeButton.getAttribute('data-cart-item') : '';
      return cartItemData ? cartItemData.split(':')[0] : '';
    });

    upsell.querySelectorAll('[data-cart-upsell-add]').forEach(addButton => {
      const variantId = addButton.getAttribute('data-variant-id');
      const inCart = cartVariantIds.includes(variantId);
      addButton.disabled = inCart;
      addButton.textContent = inCart
        ? addButton.getAttribute('data-added-label')
        : addButton.getAttribute('data-add-label');
    });
  }

  function updateCartAddonsVisibility() {
    const addonsBlock = document.querySelector('.cd-cart-addons');
    if (!addonsBlock) return;

    const cartItems = document.querySelectorAll('.cd-cart-item');
    const targetTitles = ['tourbillon', 'horizon'];

    const hasOtherProduct = Array.from(cartItems).some(item => {
      const titleElement = item.querySelector('.cd-cart-item-title');
      const title = titleElement ? titleElement.textContent.trim().toLowerCase() : '';
      return !targetTitles.some(target => title.includes(target));
    });

    const shouldHide = cartItems.length > 0 && !hasOtherProduct;

    if (shouldHide) {
      addonsBlock.querySelectorAll('.cd-cart-addon-checkbox').forEach(checkbox => {
        if (checkbox.checked) checkbox.click();
      });
    }

    addonsBlock.style.display = shouldHide ? 'none' : '';
  }

  let countRating = false;
  function ratingCart() {
    if (countRating) return
    countRating = true;
    const cartItems = document.querySelectorAll('.cd-cart-item');
    cartItems.forEach((item, indexCart) => {
      setTimeout(() => {
        const cartItemInfo = item.querySelector('.cd-cart-item-info');
        const linkProduct = item.querySelector('.cd-cart-item-title').href;

        const removeButton = item.querySelector('.cd-cart-remove-button');
        const cartItemData = removeButton.getAttribute('data-cart-item');
        const variantIdNew = cartItemData.split(':')[0];
        const variantIdOld = item.getAttribute('variant-id')
        // console.log(variantIdNew);
        // console.log(variantIdOld);
        if (variantIdNew != variantIdOld ) {
          const oldReview = item.querySelector('.yotpo-widget-instance');
          if (oldReview) oldReview.remove();

          fetch(linkProduct)
            .then(response => response.text())
            .then(html => {
              const parser = new DOMParser();
              const doc = parser.parseFromString(html, 'text/html');

              const productIdInput = doc.querySelector('.product-form__buy-buttons input[name="product-id"]');

              if (productIdInput) {
                const productId = productIdInput.value;
                // console.log('Product ID:', productId);

                setupYotpoWidget();
                function setupYotpoWidget() {
                  // console.log("remove and add");
                  if (item.querySelector('.yotpo-widget-instance')) item.querySelector('.yotpo-widget-instance').remove();

                  const newDiv = document.createElement('div');

                  newDiv.classList.add('yotpo-widget-instance', 'stars_review_yotpoo');
                  newDiv.setAttribute('data-yotpo-instance-id', '505799');
                  newDiv.setAttribute('data-yotpo-product-id', productId);
                  newDiv.setAttribute('data-yotpo-cart-product-id', '');
                  newDiv.setAttribute('data-yotpo-section-id', 'collection');
                  cartItemInfo.appendChild(newDiv);
                }


                function checkYotpoWidget() {
                    const yotpoWidget = item.querySelector('.yotpo-reviews-star-ratings-widget');
                    if (!yotpoWidget) {
                        setupYotpoWidget();
                    } else {
                        clearInterval(intervalId);
                        clearReviewText(item);
                    }
                }

                const timeout = 350;
                let intervalId = setInterval(() => {
                    checkYotpoWidget();
                }, timeout);


                item.setAttribute("variant-id", variantIdNew);
                clearReviewText(item);

              } else {
                // console.log('Product ID not found');
              }
            })
            .catch(error => {
              console.error('Error fetching the product page:', error);
            });
        }

        function clearReviewText(cartItem) {
          const widget = cartItem.querySelector('.yotpo-widget-instance');
          if (!widget) return;

          // const observer = new MutationObserver(() => {
            const textEl = widget.querySelector('.yotpo-sr-bottom-line-text');
            if (!textEl) return;

            const originalText = textEl.textContent;
            const numbersOnly = originalText.replace(/\D+/g, '');

            if (originalText !== `(${numbersOnly})` && numbersOnly !== '') {
              if (numbersOnly == 0) {
                widget.style.display = 'none';
              }
              textEl.style.visibility = "visible";
              textEl.textContent = `(${numbersOnly})`;
            }
          // });

          // observer.observe(widget, {
          //   childList: true,
          //   subtree: true,
          //   characterData: true,
          // });
        }
      }, indexCart*100);
    });
    setTimeout(() => {
      countRating = false;
    }, 1000);
  }
});